import { Button } from 'semantic-ui-react'
import styled from 'styled-components'

export const AppContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: 50px;
  background-color: #f2f7f4;
  color: white;
`

export const AppContent = styled.div`
  max-width: 800px;
  height: 100%;
  animation: scale-up-center 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @media screen and (max-width: 1100px) {
    max-width: 450px;
  }
`

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 0;
`

export const Logo = styled.img`
  max-height: 250px;
`

export const PrimaryButton = styled(Button)`
  background-color: #009DA2 !important;
  color: white !important;
  padding: 20px !important;
  margin-top: 50px !important;
  :hover {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.5) !important;
  }
`

export const ModalLink = styled.span`
  color: #009DA2;
  cursor: pointer;
  :hover {
    color: black;
  }
`



// WEBPACK FOOTER //
// ./src/components/PickingComponent/components/PickingStyles.js